import { useAuthenticatedUserQuery } from "@/api/queries/AuthQueries";
import Loading from "@/components/loading/Loading";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
    const { data, isPending } = useAuthenticatedUserQuery();
    if (isPending)
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <Loading size="large" />
            </div>
        );
    if (!data) {
        return <Navigate to="/login" />;
    }
    return <Outlet />;
};

export default PrivateRoutes;
